import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import React from 'react';
import { useState } from 'react';
import HomeIcon from '@mui/icons-material/Home';
import EditIcon from '@mui/icons-material/Edit';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import Person4Icon from '@mui/icons-material/Person4';
import {Link ,useNavigate} from 'react-router-dom';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import Footer from './Common_Components/Footer';

const JapaneseChef = () => {
  const [activePage, setActivePage] = useState("Learning");
const navigate = useNavigate();
  return (
    <div className="Life_Old_Japan_Day_1 d-flex flex-column" style={{minHeight:"100vh"}}>
        <div className='header_inner'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <ArrowBackIosIcon onClick={() => navigate('/LifeInJapan')} className='icon_1' />

                            <h2>Japanese Chef</h2>
                            <ChatBubbleOutlineIcon onClick={() => navigate('/chat-with-staff')} className="logo_1" style={{ cursor: 'pointer', color: '#ffc0cb' }} />
                        </div>


                    </div>
                </div>
            </div>
      
      <div className="container  rounded-3  shadow-sm " style={{marginTop:"150px", width: "50%" ,backgroundColor:"whitesmoke", boxShadow:"2px 4px 10px rgba(0, 0, 0, 0.4);"}}>
        <div className="row">
          <div className="col-md-12 d-flex justify-content-center mb-2">
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/writingLadki.jpeg`}
              alt="Penguine"
              className="img-fluid rounded"
              style={{ height: "250px", objectFit: "cover", marginTop: "20px" }}
            />
          </div>
        </div>

        <div className="container-fluid bg-white text-black   mt-0 p-3"style={{borderTopLeftRadius:"20px",borderTopRightRadius:"20px"}}>
          <p style={{fontSize:"20px",fontWeight:"500"}}>
           
         UH-oh! Please Visit Later 
  
          </p>
          <p>Comming Soon!</p>
           <div className="d-flex justify-content-center mb-2" >
            <button className="bg-light " style={{width:"300px", fontWeight:"600 ", border:"1px", borderRadius:"5px", padding:"10px 20px" }}>Return Back To Home</button>
          </div>
        </div>
      
      </div>

      <Footer />
    </div>
  );
};

export default JapaneseChef;
